import { useEffect } from 'react';
import { environment } from 'src/config/environment';

export const useSetDocumentTitle = (title: string) => {
  useEffect(() => {
    if (!environment.isWebSdk) {
      document.title = title;
    }
  }, [title]);
};
